var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "edit-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "50%",
            "modal-append-to-body": true,
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small",
                "validate-on-rule-change": false,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "策略名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "99",
                      size: "small",
                      placeholder: "请输入卡片名称",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "展示页面", prop: "displayPage" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择展示页面",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.displayPage,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "displayPage", $$v)
                        },
                        expression: "form.displayPage",
                      },
                    },
                    _vm._l(_vm.displayPage, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", { staticClass: "title-blue" }, [
                          _vm._v("\n              策略命中配置 "),
                          _c("i", { staticClass: "header-icon el-icon-info" }),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "platforms",
                          attrs: { label: "客户端  ", prop: "platforms" },
                        },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "top-start",
                                title: " ",
                                width: "400",
                                trigger: "hover",
                                content: "\n              ",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-question platforms-icon",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              }),
                              _c("div", [
                                _vm._v(
                                  "\n                1. 默认勾选，值为空时，则覆盖所有版本"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                2. 按输入版本号范围覆盖版本"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                 2.1. 只输入最小版本号，最大版本为空时，则代表大于最小版本号的版本都生效"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                 2.2. 最小和最大版本号同时输入，则只生效该范围内"
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                3. 当取消勾选时，则该端不生效页面策略\n              "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.platformsChange },
                              model: {
                                value: _vm.platforms,
                                callback: function ($$v) {
                                  _vm.platforms = $$v
                                },
                                expression: "platforms",
                              },
                            },
                            _vm._l(_vm.platform, function (item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.form.platforms, function (platform, index) {
                        return _c(
                          "el-form-item",
                          {
                            key: index,
                            attrs: {
                              label: `${platform.platform}客户端版本`,
                              prop: `platforms.${index}.minClientVersion`,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("el-input-number", {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    size: "small",
                                    min: 0,
                                    clearable: "",
                                  },
                                  model: {
                                    value: platform.minClientVersion,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        platform,
                                        "minClientVersion",
                                        $$v
                                      )
                                    },
                                    expression: "platform.minClientVersion",
                                  },
                                }),
                                _c("el-input-number", {
                                  attrs: {
                                    size: "small",
                                    min: 0,
                                    clearable: "",
                                  },
                                  model: {
                                    value: platform.maxClientVersion,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        platform,
                                        "maxClientVersion",
                                        $$v
                                      )
                                    },
                                    expression: "platform.maxClientVersion",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      _c(
                        "el-form-item",
                        { attrs: { label: "渠道选择", prop: "channelType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.form.channelType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "channelType", $$v)
                                },
                                expression: "form.channelType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("全部渠道"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("渠道白名单"),
                              ]),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("渠道黑名单"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.channelType === 2 || _vm.form.channelType === 3
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "指定渠道", prop: "appIds" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "80%" },
                                attrs: { type: "textarea" },
                                on: {
                                  focus: function ($event) {
                                    return _vm.channelInputClick(_vm.item)
                                  },
                                },
                                model: {
                                  value: _vm.form.appIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "appIds", $$v)
                                  },
                                  expression: "form.appIds",
                                },
                              }),
                              _c("channel-popups", {
                                attrs: {
                                  isAppendToBody: true,
                                  modelIsAppendToBody: false,
                                  "app-id": _vm.form.channel.ids,
                                  visible: _vm.channelVisible,
                                  multiple: true,
                                },
                                on: {
                                  "update:visible": function ($event) {
                                    _vm.channelVisible = $event
                                  },
                                  comfirm: function ($event) {
                                    return _vm.channelConfirm($event, _vm.item)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "指定UID", prop: "uid" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "80%" },
                            attrs: {
                              placeholder: "多个用英文逗号分隔",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.form.uid,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "uid", $$v)
                              },
                              expression: "form.uid",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _vm.form.displayPage == 1
                    ? _c(
                        "el-collapse-item",
                        { attrs: { name: "2" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c("div", { staticClass: "title-blue" }, [
                              _vm._v("投屏功能配置 "),
                              _c("i", {
                                staticClass: "header-icon el-icon-info",
                              }),
                            ]),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "功能配置",
                                prop: "screenConfig",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择功能配置" },
                                  on: { change: _vm.screenConfigChange },
                                  model: {
                                    value: _vm.form.screenConfig,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "screenConfig", $$v)
                                    },
                                    expression: "form.screenConfig",
                                  },
                                },
                                _vm._l(
                                  _vm.screenConfigSelectList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: `(${item.value}) ${item.label}`,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-form-item", { attrs: { label: "行数据" } }, [
                            _vm.form.screenConfig
                              ? _c(
                                  "div",
                                  { staticClass: "config-row-data" },
                                  _vm._l(
                                    _vm.currentScreenConfig,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "config-row-data-item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "config-row-data-item-label",
                                              staticStyle: { color: "#858585" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    `行${index + 1}：${item}`
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "3" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", { staticClass: "title-blue" }, [
                          _vm._v("\n              内容卡片配置 "),
                          _c("i", { staticClass: "header-icon el-icon-info" }),
                        ]),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡片选择", prop: "cardIds" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: { size: "small" },
                              on: { click: _vm.selectAppCards },
                            },
                            [_vm._v("选择")]
                          ),
                          _vm.form.cardIds.length
                            ? _c(
                                "avue-crud",
                                {
                                  ref: "crud",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    option: _vm.option,
                                    data: _vm.form.cardIds,
                                  },
                                  on: { "sortable-change": _vm.sortChange },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "coverImg",
                                        fn: function ({ row }) {
                                          return [
                                            row.coverImg
                                              ? _c("el-image", {
                                                  staticStyle: {
                                                    width: "100px",
                                                    height: "100px",
                                                  },
                                                  attrs: {
                                                    src: row.coverImg,
                                                    fit: "scale-down",
                                                  },
                                                })
                                              : _c("span", [
                                                  _vm._v("暂无图片"),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "menu",
                                        fn: function ({ row }) {
                                          return [
                                            !row.top
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goSticky(row)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("置顶")]
                                                )
                                              : _vm._e(),
                                            row.top
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.cancelSticky(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("取消置顶")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delCards(row)
                                                  },
                                                },
                                              },
                                              [_vm._v("移除")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2470805517
                                  ),
                                },
                                [_c("template", { slot: "mySearch" })],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "30px" },
                  attrs: { label: "备注", prop: "remark" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "80%" },
                    attrs: {
                      placeholder: "请输入备注",
                      type: "textarea",
                      maxlength: "999",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("生效")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("失效")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "btn-container",
              staticStyle: { "text-align": "right", "margin-top": "20px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.save },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("TimeSelect", {
        ref: "timeSelect",
        on: { save: _vm.cardTopTimeSave },
      }),
      _c("MultipleCards", {
        ref: "multipleCards",
        on: { save: _vm.getContentList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }